import { render } from "./DrainingCharacteristics.vue?vue&type=template&id=ee47b02e"
import script from "./DrainingCharacteristics.vue?vue&type=script&lang=js"
export * from "./DrainingCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script